import type { DragData } from "./dragData"

/**
 * A kind of thing that can be dragged, and the value it carries. Its key is a
 * symbol only the kind holds, so nothing but `data` puts a value where `from`
 * reads one, and nothing else dragged on the page is taken for this kind.
 */
export function dragKind<T>(name: string) {
  const key = Symbol(name)
  return {
    /** Tags a value as this kind, for a draggable's data. */
    data: (value: T) => ({ [key]: value }),
    /** The value a drag's data carries as this kind, if it is this kind. */
    from: (data: DragData) => data[key] as T | undefined,
  }
}

export type DragKind<T> = ReturnType<typeof dragKind<T>>
